const RATE_FREQUENCIES = {
  hourly: "HOURLY",
  daily: "DAILY",
  weekly: "WEEKLY",
  monthly: "MONTHLY",
  yearly: "YEARLY",
};

const CLIENT_BUDGET_RATE_FREQUENCIES = [
  { value: "HOURLY", label: "Hourly" },
  { value: "YEARLY", label: "Yearly" },
];

const MINIMUM_TARGET_RATE = 10;

export { CLIENT_BUDGET_RATE_FREQUENCIES, MINIMUM_TARGET_RATE };

export default RATE_FREQUENCIES;
